<template>
  <v-app id="app">
    <!-- GLOBAL LOADER -->
    <div class="global-loader-cont" v-if="loader">
      <v-card color="primary" dark class="global-loader" id="global-loader">
        <v-card-text>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </div>

    <!-- APP UPDATE SNACKBAR -->
    <v-snackbar :timeout="-1" bottom right v-model="newversion_snackbar">
      {{ $t("global.new_version") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" class="darken-2" small v-bind="attrs" @click="refreshPage()">{{ $t("global.refresh") }}</v-btn>
      </template>
    </v-snackbar>

    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "my-master",

  data() {
    return {
      dialog: true
    }
  },

  created: function() {
    ///////////////////////////////////////////////////////////
    // AXIOS
    ///////////////////////////////////////////////////////////

    this.$checkAppVersion()

    axios.interceptors.request.use(
      (config) => {
        if (this.$store.getters["master/axiosHideLoader"]) {
        } else {
          this.$store.dispatch("master/setLoader", true)
        }

        this.$globalMessages("", "", false)

        // Headers
        config.headers["X-Locale"] = this.$getSetting("locale")
        config.headers["Vue-Check-Version"] = this.$store.getters["master/versionCheck"]
        config.headers["Vue-Admin-App-Version"] = process.env.VUE_APP_VERSION

        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      (response) => {
        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        this.$store.dispatch("master/setAxiosHideLoader", false)

        // Hide Global Messages
        // this.$globalMessages("", "", false);
        return response
      },
      (error) => {
        // Version mismatch - Reload page
        /*if (419 === error.response.status) {
          window.location.reload(true)
        }*/

        // Form error messages
        if (
          422 === error.response.status ||
          410 === error.response.status ||
          412 === error.response.status ||
          413 === error.response.status ||
          406 === error.response.status ||
          498 === error.response.status
        ) {
          let errors = this.$formatErrorMessages(error.response.data.errors)
          this.$globalMessages(errors, "error", true, error.response.status, error.response.data.extras)
        }

        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        return Promise.reject(error)
      }
    )

    ///////////////////////////////////////////////////////////
    // ROUTES
    ///////////////////////////////////////////////////////////
    this.$router.beforeEach((to, from, next) => {
      // Hide Global Messages
      this.$globalMessages("", "", false)

      let path = to.path
      let module = to.meta.module
      let permissions = to.meta.permissions

      // Fetch notifications
      this.$store.dispatch("notification/syncNotifications")

      // increase route count
      this.$store.dispatch("master/increaseRouteCount")
      var routeCount = this.$store.getters["master/routeCount"]

      if (routeCount > 0) {
        this.$store.dispatch("master/setVersionCheck", true)
      }

      this.$setCurrentPath(path)
      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (hasPermission || module == "auth") {
          this.$checkAppVersion();
          next()
        } else {
          this.$setCurrentPath(from.path)
          this.$setCurrentModule(from.meta.module)
          this.routeFailed(false)
        }
      } else {
        this.$checkAppVersion();
        next()
      }
    })

    this.routeInit()

    ///////////////////////////////////////////////////////////
    // AUTH
    ///////////////////////////////////////////////////////////
    this.check()

    ///////////////////////////////////////////////////////////
    // NOTIFICATION
    ///////////////////////////////////////////////////////////
    this.$store.dispatch("notification/syncNotifications")
    let vm = this
    setInterval(function() {
      let showNotificationBar = false
      let activeNotifications = []
      let notifications = vm.$store.getters["notification/newNotifications"]

      notifications.forEach((notif, index) => {
        let current_datetime = vm.moment().utc()
        let start_datetime = vm.moment.utc(notif.start_datetime_utc)
        let end_datetime = vm.moment.utc(notif.end_datetime_utc)

        let validStartDateTime = start_datetime.isBefore(current_datetime)
        let validEndDateTime = end_datetime.isAfter(current_datetime)

        //console.log("current_datetime: " + current_datetime.format() + " | start_datetime: " + start_datetime.format() + " | end_datetime: " + end_datetime.format())
        //console.log("validStartDateTime: " + validStartDateTime + " | validEndDateTime: " + validEndDateTime)

        if (validStartDateTime && validEndDateTime) {
          if (notif.type == "bar") {
            showNotificationBar = true
          }

          activeNotifications.push(notif)
        }
      })

      vm.$store.dispatch("notification/setActiveNotifications", activeNotifications)
      vm.$store.dispatch("notification/setShowNotificationBar", showNotificationBar)
    }, 3000)
  },

  computed: {
    loader: {
      get() {
        return this.$store.getters["master/loader"]
      },
      set(value) {
        this.$store.dispatch("master/setLoader", value)
      }
    },
    locale: {
      get() {
        let locale = this.$getSetting("locale")
        return locale ? locale : "en"
      },
      set(value) {
        if (value) {
          this.$updateSetting("locale", value)
          this.$i18n.locale = value
        }
      }
    },
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    newversion_snackbar: {
      get() {
        return this.$store.getters["master/newVersionSnackbar"]
      },
      set(value) {
        this.$store.dispatch("master/setNewVersionSnackbar", value)
      }
    }
  },

  watch: {
    locale: {
      handler: function(val, oldVal) {
        this.locale = val
      }
    }
  },

  methods: {
    refreshPage() {
      window.location.reload(true)
    },
    check() {
      let user = this.$store.getters["auth/localUser"]
      let vm = this

      if (this.$checkAllCookies() && user) {
        let access_token = this.$cookies.get(`${this.COOKIE_PREFIX}access_token`)

        vm.$setAuthorization(access_token)

        axios({
          method: "get",
          url: this.API_URL + "auth/user"
        })
          .then((res) => {
            let forcechangepassword = res.data.data.force_change_password
            let status = res.data.data.status
            let path = vm.$router.currentRoute.path

            vm.$init(access_token, res.data.data)

            if (forcechangepassword && status == 1 && !path.endsWith("/forcechangepassword")) {
              this.$store.dispatch("master/setRouteCount", -1)
              this.$router.push("/auth/" + this.locale + "/forcechangepassword").catch(err => {})
            }

            if (vm.$router.currentRoute.path == "/" || vm.$router.currentRoute.path == "/app" || vm.$router.currentRoute.path == "/app/") {
              if (status == 1 && !forcechangepassword) {
                this.$store.dispatch("master/setRouteCount", -1)
                this.$router.push(this.BACKEND_URL + "/dashboard").catch(err => {})
              }
            } else {
              vm.routeInit()
            }
          })
          .catch((err) => {
            if (err.response.status == 401) {
              vm.$clearCookies()
              vm.$store.dispatch("settings/reset", vm)
              vm.$store.dispatch("auth/no/logout", vm)
            }
          })
      } else {
        this.$clearCookies()
        this.$store.dispatch("settings/reset", this)
        localStorage.removeItem("__crrntUser")

        let path = vm.$router.currentRoute.path
        let segments = ["/f/", "/auth/"]
        let allowed = false

        for (let segment of segments) {
          if (path.startsWith(segment)) {
            allowed = true
          }
        }

        if (!allowed) {
          vm.$store.dispatch("master/setRouteCount", -1)
          vm.$router.push("/auth/no/login").catch(err => {})
        } else {
          vm.$router.push(path).catch(err => {})
        }
      }
    },

    routeCheck(permissions) {
      let bool = false

      for (let i in permissions) {
        const permission = permissions[i]
        if (this.$can(permission) || permission == "all") {
          bool = true
        }
      }

      if (!bool && this.$hasRole("system-developer")) {
        bool = true
      }

      return bool
    },

    routeInit() {
      let module = this.$router.currentRoute.meta.module
      let permissions = this.$router.currentRoute.meta.permissions

      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (!hasPermission) {
          this.routeFailed()
        }
      }
    },

    routeFailed(redirect = true) {
      let vm = this

      vm.$swal({
        title: this.$t("global.no_permission_title"),
        text: this.$t("global.no_permission_text"),
        icon: "error"
      }).then(function() {
        if (redirect) {
          vm.$store.dispatch("master/setRouteCount", -1)
          vm.$router.push(vm.BACKEND_URL + "/dashboard").catch(err => {})
        }
      })
    }
  }
}
</script>
